import { render, staticRenderFns } from "./TechPassed.vue?vue&type=template&id=6a53c0de&scoped=true"
import script from "./TechPassed.vue?vue&type=script&lang=js"
export * from "./TechPassed.vue?vue&type=script&lang=js"
import style0 from "./TechPassed.vue?vue&type=style&index=0&id=6a53c0de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a53c0de",
  null
  
)

export default component.exports